import React, { ReactElement } from "react";
import { applyRedactionFont } from "services/strings";
import "./style.scss";

export interface KeyValuePairsProps {
  object: Record<string, unknown>;
}

class KeyValuePairs extends React.Component<KeyValuePairsProps> {
  renderKeyValuePairs(): ReactElement[] {
    const { object } = this.props;
    const keys = Object.keys(object).sort();

    return keys.filter((key) => {
      const val = object[key];

      // only display strings, arrays, numbers, and booleans
      return Boolean(val) && (Array.isArray(val) || typeof val !== "object");
    }).map((key) => {
      const convertedKey = key.replace(/([A-Z])/g, " $1").trim();
      let val = object[key];

      if (typeof val === "boolean" || Array.isArray(val)) {
        // need to stringify booleans and arrays so they'll render properly
        val = JSON.stringify(val);
      }

      return (
        <div key={convertedKey} className="KeyValuePairs__pair">
          <div className="KeyValuePairs__pair__key">{convertedKey}</div>
          {/* eslint-disable-next-line react/no-danger */}
          <div className="KeyValuePairs__pair__value" dangerouslySetInnerHTML={{ __html: applyRedactionFont(val as string) }} />
        </div>
      );
    });
  }

  render(): ReactElement {
    return (
      <div className="KeyValuePairs">
        {this.renderKeyValuePairs()}
      </div>
    );
  }
}

export default KeyValuePairs;
